export class FilterDisplay {
  id: any;
  text: string;
}
